/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePrebidRequestDto } from '../../models/create-prebid-request-dto';
import { PrebidDto } from '../../models/prebid-dto';

export interface CreatePrebid$Params {
  'X-API-Version'?: string;
      body: CreatePrebidRequestDto
}

export function createPrebid(http: HttpClient, rootUrl: string, params: CreatePrebid$Params, context?: HttpContext): Observable<StrictHttpResponse<PrebidDto>> {
  const rb = new RequestBuilder(rootUrl, createPrebid.PATH, 'post');
  if (params) {
    rb.header('X-API-Version', params['X-API-Version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PrebidDto>;
    })
  );
}

createPrebid.PATH = '/api/prebids';
